var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatH2I = function SvgChatH2I(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M14.118 16a.356.356 0 0 1-.352-.35 2.273 2.273 0 0 1 1.209-1.738c.538-.4.867-.676.867-1.053a.541.541 0 0 0-.6-.525.583.583 0 0 0-.6.594.353.353 0 0 1-.352.354.354.354 0 0 1-.355-.354 1.437 1.437 0 0 1 .307-.857 1.261 1.261 0 0 1 1-.445 1.251 1.251 0 0 1 1.315 1.234c0 .775-.644 1.244-1.16 1.619a2.979 2.979 0 0 0-.832.813h1.727a.36.36 0 0 1 .356.359.358.358 0 0 1-.356.35zm-2.742-.412v-3.166H8.35v3.156a.421.421 0 0 1-.422.422.414.414 0 0 1-.427-.412V8.422A.42.42 0 0 1 7.928 8a.416.416 0 0 1 .411.422v3.166h3.026V8.422A.426.426 0 0 1 11.787 8a.426.426 0 0 1 .427.422v7.156a.422.422 0 0 1-.427.422.411.411 0 0 1-.411-.412z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatH2I);
export default ForwardRef;